import {
  getTimeRangeDict,
  dateToJavaDateStr,
} from 'ui-components/get-time-range-map'

const getDefaultProps = () => {
  const [fromDate, toDate] = getTimeRangeDict(new Date())['Past 7 days']
  return {
    from: dateToJavaDateStr(fromDate),
    to: dateToJavaDateStr(toDate),
  }
}

export default getDefaultProps
